export const EXPIRY = () => {
  let expiryTime = new Date(Date.now() + 5 * 60000).getTime(); // 5 Minutes
  return expiryTime;
};

export const API_ROOT =
  process.env.REACT_APP_API_HOST || "http://localhost:8000";

export const HEADER = process.env.REACT_APP_API_KEY || "";
